module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.article.title[_vm.locale]))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.article.text[_vm.locale])
    }
  }), _vm._v(" "), _c('gallery', {
    attrs: {
      "images": _vm.images,
      "index": _vm.index,
      "options": {
        displayClass: 'blueimp-gallery-display-fix'
      }
    },
    on: {
      "close": function($event) {
        _vm.index = null
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gallery-container"
  }, _vm._l((_vm.images), function(image, imageIndex) {
    return _c('img', {
      staticClass: "image",
      attrs: {
        "src": ((image.split('.jpg').shift()) + "-thumbnail.jpg")
      },
      on: {
        "click": function($event) {
          _vm.index = imageIndex
        }
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "30px",
      "text-align": "right",
      "padding-right": "25px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": ("/hireink/" + (_vm.article.slug))
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('Gallery')) + "\n    ")])], 1), _vm._v(" "), (!_vm.noSeparator) ? _c('div', {
    staticClass: "separator"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/dots.svg"),
      "alt": "separator"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b088cb4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsArticle.vue
// module id = 949
// module chunks = 0